import { Box, SxProps, Theme, alpha, styled } from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";

import { useAppDispatch } from "app/hooks";
import { SitesAutocomplete } from "./SitesAutocomplete";
import { sitesThunks } from "./store/slice";

// styled elements
const SearchIconWrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));

export interface SiteSearchProps {
    sx?: SxProps<Theme>;
    minSearchQueryCharacterLength?: number;
}

export function SiteSearch(props: SiteSearchProps) {
    // hooks
    const dispatch = useAppDispatch();

    // component
    return (
        <Box sx={[...(Array.isArray(props.sx) ? props.sx : [props.sx])]}>
            <Box
                sx={{
                    ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
                    position: "relative",
                    borderRadius: 1,
                    backgroundColor: (theme) =>
                        alpha(theme.palette.common.white, 0.15),
                    "&:hover": {
                        backgroundColor: (theme) =>
                            alpha(theme.palette.common.white, 0.25),
                    },
                    marginLeft: {
                        xs: 0,
                        sm: 1,
                    },
                    width: "100%",
                }}
            >
                <SearchIconWrapper>
                    <SearchIcon />
                </SearchIconWrapper>
                <SitesAutocomplete
                    minSearchQueryCharacterLength={
                        props.minSearchQueryCharacterLength
                    }
                    sx={(theme) => ({
                        color: "info.main",
                        ...theme.typography.overline,
                        ".MuiAutocomplete-input": {
                            color: "common.white",
                            paddingLeft: (theme) =>
                                `calc(1em + ${theme.spacing(4)}) !important`,
                        },
                    })}
                    onChange={(value) => {
                        if (value) {
                            // select site
                            dispatch(
                                sitesThunks.fetchSelectedSiteSearchResultAsync(
                                    value,
                                ),
                            );
                        }
                    }}
                    hideSelectedValue={true}
                    variant="outlined"
                />
            </Box>
        </Box>
    );
}
